import { orderTermIsNet60 } from "../../utils/orderTermIsNet60";
import { orderTermIsPaymentOnShipment } from "../../utils/orderTermIsPaymentOnShipment";
import { orderWasAlreadyCharged } from "../../utils/orderWasAlreadyCharged";
export var RefundsIA = function RefundsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return REFUNDS(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getDescription(context, strictLocalize);
    }
  };
};
var getDescription = function getDescription(context, strictLocalize) {
  var withSharedParagraphs = function withSharedParagraphs(intro) {
    return [intro(strictLocalize), PLEASE_NOTE(strictLocalize), FREE_RETURNS_ELIGIBLE_FOR_FIRST_BRAND_ORDER(strictLocalize)];
  };
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return withSharedParagraphs(REFUNDS_EXPLANATION);
  }
  if (orderTermIsNet60(brandOrder) && !orderWasAlreadyCharged(brandOrder)) {
    return withSharedParagraphs(WE_WILL_NOT_CHARGE_YOU);
  }
  if (orderTermIsPaymentOnShipment(brandOrder)) {
    return withSharedParagraphs(YOU_WILL_GET_A_REFUND);
  }
  return withSharedParagraphs(REFUNDS_EXPLANATION);
};
var REFUNDS = function REFUNDS(strictLocalize) {
  return strictLocalize({
    id: "j0Zb++",
    defaultMessage: [{
      "type": 0,
      "value": "Comment fonctionnent les remboursements ?"
    }]
  });
};
var WE_WILL_NOT_CHARGE_YOU = function WE_WILL_NOT_CHARGE_YOU(strictLocalize) {
  return strictLocalize({
    id: "nlChIa",
    defaultMessage: [{
      "type": 0,
      "value": "Étant donné que vous avez passé commande avec le paiement à 60 jours et que la facture n'a pas encore été payée, nous ne vous facturerons pas les articles retournés."
    }]
  });
};
var FREE_RETURNS_ELIGIBLE_FOR_FIRST_BRAND_ORDER = function FREE_RETURNS_ELIGIBLE_FOR_FIRST_BRAND_ORDER(strictLocalize) {
  return strictLocalize({
    id: "8EzeWX",
    defaultMessage: [{
      "type": 0,
      "value": "Les retours gratuits ne sont possibles que sur votre première commande auprès d'une marque. Les frais de retour sont couverts par Faire. En revanche, les frais d'expédition initiaux et les droits de douane ne sont pas remboursables. Si une facture a été payée avec un crédit Faire et une carte de paiement, le crédit sera remboursé en premier. Si le crédit Faire Direct a été initialement utilisé pour payer une commande qui a été retournée, il ne sera pas automatiquement restauré sur votre compte Faire en tant que crédit."
    }]
  });
};
var YOU_WILL_GET_A_REFUND = function YOU_WILL_GET_A_REFUND(strictLocalize) {
  return strictLocalize({
    id: "HOxj0J",
    defaultMessage: [{
      "type": 0,
      "value": "Puisque vous avez passé commande avec le paiement à l'expédition, le coût des articles retournés sera remboursé directement sur votre mode de paiement initial au moment où le retour sera scanné par le transporteur. Le remboursement apparaitra sur votre mode de paiement dans les 5 à 10 jours ouvrés."
    }]
  });
};
var REFUNDS_EXPLANATION = function REFUNDS_EXPLANATION(strictLocalize) {
  return strictLocalize({
    id: "DB4OtG",
    defaultMessage: [{
      "type": 0,
      "value": "Si vous avez passé commande avec le paiement à 60 jours et que la facture n'a pas encore été payée, nous ne vous facturerons pas les articles retournés. Si vous avez passé commande avec le paiement à l'expédition, le coût des articles retournés sera remboursé directement sur votre mode de paiement initial au moment où le retour sera scanné par le transporteur. Le remboursement apparaitra sur votre mode de paiement dans les 5 à 10 jours ouvrés."
    }]
  });
};
var PLEASE_NOTE = function PLEASE_NOTE(strictLocalize) {
  return strictLocalize({
    id: "Vr8ECj",
    defaultMessage: [{
      "type": 0,
      "value": "Remarque :"
    }]
  });
};